/**
 * To The Top Button
 * Scrolls page back to top when clicked
 */

export const initToTheTop = () => {
  const toTheTopButton = document.getElementById('toTheTop');
  
  if (!toTheTopButton) return;
  
  toTheTopButton.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}; 